/**
 * Format and validate Canadian phone numbers.
 * Accepts: 2505551234, 250-555-1234, (250) 555-1234, +12505551234, 1-250-555-1234
 * Returns: +12505551234 (E.164) or null if invalid
 */
export function formatCanadianPhone(input) {
  if (!input) return '';
  const digits = input.replace(/\D/g, '');

  let normalized;
  if (digits.length === 10) {
    normalized = `+1${digits}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    normalized = `+${digits}`;
  } else {
    return null; // invalid
  }

  return normalized;
}

/**
 * Display format: (250) 555-1234
 */
export function displayPhone(input) {
  if (!input) return '';
  const digits = input.replace(/\D/g, '');
  let d = digits;
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  if (d.length !== 10) return input;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/**
 * Auto-format as user types: (2__) ___-____
 */
export function autoFormatPhone(input) {
  const digits = input.replace(/\D/g, '');
  let d = digits;
  // Strip leading 1 if they typed +1 or 1
  if (d.length > 10 && d.startsWith('1')) d = d.slice(1);
  if (d.length > 10) d = d.slice(0, 10);

  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function isValidCanadianPhone(input) {
  return formatCanadianPhone(input) !== null;
}
